import React from 'react'
import { useEffect, ReactNode } from 'react'
import { useHistory } from 'react-router-dom'

import { globalWindow } from '@emico/ssr-utils'

export interface ScrollRestorationState {
  /** Used to disable scroll restoration for a single event */
  scrollRestoration?: false
}

export function useScrollRestoration() {
  const history = useHistory()

  useEffect(
    () =>
      history.listen((location, action) => {
        // Another script will handle scroll restoration if scrollRestoration is
        // set to manual.
        if (globalWindow?.history.scrollRestoration === 'manual') {
          return
        }

        // There are three possible actions:
        //  - POP: this one is handled by the browser, we should not interfere
        //  - REPLACE: there is no need to scroll here, this is used to update
        //    for example a filters page.
        //  - PUSH: Here we need to scroll to the top, this is not handled by
        //    the browser, so we should do it.
        if (action !== 'PUSH') {
          return
        }

        // There is also a custom mechanism to disable scrollRestoration for a
        // single push, this is set in the push state.
        const state = location.state as ScrollRestorationState | undefined
        if (state?.scrollRestoration === false) {
          return
        }

        globalWindow?.scrollTo(0, 0)
      }),
    [history],
  )
}

interface Props {
  children?: ReactNode
}

export const ScrollRestoration = ({ children }: Props) => {
  useScrollRestoration()
  return <>{children}</>
}
